// extracted by mini-css-extract-plugin
export default {"success":"default_success__8S0Yp","icon":"default_icon__D5iO-","headline":"default_headline__HxyWs","note":"default_note__ovt32","link":"default_link__+XmWn"};